module.exports = require("@swa-ui/placements/src/BlockPlacement/BlockPlacement.module.scss");